import {
  Card,
  CardContent,
  Typography,
  Box
} from "@mui/material";
import "@emotion/react";
import "@emotion/styled";
import SkillBadge from "./SkillBadge";

export default function StoryCard({
  time = "sometime",
  title = "sometitle",
  content = "somecontent",
  skills = []
}) {
  const skillBadges = skills.map((sk) => (<SkillBadge key={sk} skill={sk}/>));

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography gutterBottom sx={{ color: "text.secondary", fontSize: 14 }}>
          {time}
        </Typography>
        <Typography variant="h5" component="div">
          {title}
        </Typography>
        <Typography variant="body2">{content}</Typography>
      </CardContent>
      {skillBadges.length > 0 && (
        <Box sx={{ px: 2, pb: 2 }}>
          {skillBadges}
        </Box>
      )}
    </Card>
  );
}
